/* TryAgain PDP mechanics: variant picker, gallery, accordion, scroll reveals. */
(function () {
  'use strict';

  function init() {
    var hero = document.querySelector('.pdp-hero');
    if (!hero) return;
    var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    // captured before syncVariant() rewrites the URL with replaceState
    var deepLinkVariant = /[?&]variant=/.test(location.search);

    /* ---------- variant picker ---------- */
    var cfgEl = hero.querySelector('[data-ta-variants]');
    var variants = cfgEl ? JSON.parse(cfgEl.textContent) : [];
    var idInput = hero.querySelector('[data-ta-variant-id]');
    var priceEl = hero.querySelector('[data-ta-price]');
    var comparePriceEl = hero.querySelector('[data-ta-compare-price]');
    var liquidationLabel = hero.querySelector('[data-ta-liquidation-label]');
    var atcBtn = hero.querySelector('[data-ta-atc]');
    var groups = [].slice.call(hero.querySelectorAll('.pdp-opt'));

    function selectedOptions() {
      return groups.map(function (g) {
        var c = g.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    function variantFor(sel) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === sel[i]; });
      });
    }
    function setGroupValue(gi, val) {
      [].forEach.call(groups[gi].querySelectorAll('input[type=radio]'), function (inp) {
        inp.checked = (inp.value === val);
      });
    }
    // Some products carry correlated options (the jacket's Length is tied to Color:
    // Black=>Full, Ivory=>Cropped), so flipping one option can land on a combo that has
    // no variant (e.g. Ivory + Full) and dead-end on "Unavailable" even when the colour
    // is fully in stock. Snap the sibling options to the nearest real variant that keeps
    // the value the visitor just changed. For a complete matrix this is always a no-op.
    function reconcile(changedIdx) {
      var sel = selectedOptions();
      if (variantFor(sel) || changedIdx == null) return sel;
      var want = sel[changedIdx];
      var target = variants.find(function (v) { return v.available && v.options[changedIdx] === want; })
                || variants.find(function (v) { return v.options[changedIdx] === want; });
      if (!target) return sel;
      groups.forEach(function (g, gi) { setGroupValue(gi, target.options[gi]); });
      return target.options.slice();
    }
    function syncVariant(changedIdx) {
      var sel = reconcile(changedIdx);
      var match = variantFor(sel);
      if (!match) {
        if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = match.price;
      if (comparePriceEl) {
        comparePriceEl.textContent = match.comparePrice || '';
        comparePriceEl.hidden = !match.onSale;
      }
      if (liquidationLabel) liquidationLabel.hidden = !match.onSale;
      var stickyPrice = document.querySelector('[data-ta-price-sticky]');
      var stickyComparePrice = document.querySelector('[data-ta-compare-price-sticky]');
      if (stickyPrice) stickyPrice.textContent = match.price;
      if (stickyComparePrice) {
        stickyComparePrice.textContent = match.comparePrice || '';
        stickyComparePrice.hidden = !match.onSale;
      }
      if (atcBtn) {
        atcBtn.disabled = !match.available;
        atcBtn.textContent = match.available ? (atcBtn.dataset.label || 'Add to cart') : 'Sold out';
      }
      try {
        var url = new URL(location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url);
      } catch (e) { /* noop */ }
      if (typeof syncGalleryToVariant === 'function') syncGalleryToVariant(sel);
    }
    if (atcBtn) atcBtn.dataset.label = atcBtn.textContent.trim();
    groups.forEach(function (g, gi) { g.addEventListener('change', function () { syncVariant(gi); }); });
    if (groups.length) syncVariant();

    /* ---------- sticky buy bar: always-reachable Add to cart ---------- */
    var stickyBar = document.querySelector('[data-ta-stickybar]');
    var form = document.getElementById('ta-product-form');
    if (stickyBar && form && atcBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        stickyBar.hidden = entries[0].isIntersecting; // show bar only when the real ATC is off-screen
      }, { threshold: 0 });
      io.observe(atcBtn);
      var stickyAtc = stickyBar.querySelector('[data-ta-sticky-atc]');
      if (stickyAtc) {
        stickyAtc.addEventListener('click', function () {
          if (atcBtn.disabled) return;
          if (form.requestSubmit) form.requestSubmit(); else form.submit();
        });
      }
    }

    /* ---------- complete-the-set upsell (same-color companion) ---------- */
    // The companion is always added in the SAME color the visitor selected. The
    // primary companion may not stock every color (e.g. the seamless bra has no
    // green/orchid) — a second candidate covers those, so green leggings pair with
    // the green support bra, not a fallback black one. The card updates to match.
    var setEl = hero.querySelector('[data-ta-set]');
    var setBtn = hero.querySelector('[data-ta-set-add]');
    var compsEl = hero.querySelector('[data-ta-companions]');
    if (setEl && setBtn && compsEl) {
      var companions = JSON.parse(compsEl.textContent);
      var setLabel = setBtn.textContent;
      var setImg = setEl.querySelector('[data-ta-set-img]');
      var setTitle = setEl.querySelector('[data-ta-set-title]');
      var setPrice = setEl.querySelector('[data-ta-set-price]');
      var chosen = null;
      function pickCompanion(color, size) {
        // 1st: a candidate that matches BOTH the chosen color and size (e.g. M black -> M black bra)
        for (var i = 0; i < companions.length; i++) {
          var exact = companions[i].variants.find(function (v) { return v.available && v.options.indexOf(color) !== -1 && v.options.indexOf(size) !== -1; });
          if (exact) return { comp: companions[i], variant: exact };
        }
        // 2nd: same color, any size
        for (var c = 0; c < companions.length; c++) {
          var byColor = companions[c].variants.find(function (v) { return v.available && v.options.indexOf(color) !== -1; });
          if (byColor) return { comp: companions[c], variant: byColor };
        }
        // 3rd: any available
        for (var j = 0; j < companions.length; j++) {
          var any = companions[j].variants.find(function (v) { return v.available; });
          if (any) return { comp: companions[j], variant: any };
        }
        return null;
      }
      function updateSet() {
        var sel = selectedOptions(); // [Color, Size]
        chosen = pickCompanion(sel[0], sel[1]);
        if (!chosen) { setEl.hidden = true; return; }
        setEl.hidden = false;
        if (setImg && chosen.comp.img) setImg.src = chosen.comp.img;
        if (setTitle) setTitle.textContent = chosen.comp.title;
        if (setPrice) setPrice.textContent = chosen.variant.price;
      }
      groups.forEach(function (g) { g.addEventListener('change', updateSet); });
      updateSet();
      setBtn.addEventListener('click', function () {
        if (!chosen || !idInput) return;
        setBtn.disabled = true; setBtn.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(idInput.value, 10), quantity: 1 }, { id: chosen.variant.id, quantity: 1 }] })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location.href = '/cart';
        }).catch(function () { setBtn.disabled = false; setBtn.textContent = setLabel; });
      });
    }

    /* ---------- gallery ---------- */
    var slides = [].slice.call(hero.querySelectorAll('.pdp-slide'));
    var thumbs = [].slice.call(hero.querySelectorAll('.pdp-thumb'));
    // the Liquid template marks the start slide (the video when there is one)
    var startIndex = slides.findIndex(function (s) { return s.classList.contains('on'); });
    if (startIndex < 0) startIndex = 0;
    function activateSlide(i) {
      slides.forEach(function (s, k) {
        s.classList.toggle('on', k === i);
        var vid = s.querySelector('video');
        if (vid) { if (k === i) { vid.play().catch(function () {}); } else { vid.pause(); } }
      });
      thumbs.forEach(function (x, k) { x.classList.toggle('on', k === i); });
    }
    slides.forEach(function (s) {
      var vid = s.querySelector('video');
      if (vid && !s.classList.contains('on')) vid.pause();
    });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { activateSlide(parseInt(t.dataset.thumb, 10)); });
    });

    // start video plays on desktop immediately; on mobile we keep it preload=none and
    // only fetch/play the ~3MB clip after the first interaction, so the LCP stays the
    // lightweight (preloaded) poster instead of waiting on the video download.
    var startVid = slides[startIndex] && slides[startIndex].querySelector('video');
    if (startVid) {
      var playStart = function () { startVid.preload = 'auto'; var p = startVid.play(); if (p && p.catch) p.catch(function () {}); };
      if (window.matchMedia('(min-width:769px)').matches) {
        playStart();
      } else {
        var kick = function () { playStart(); ['touchstart', 'scroll', 'click'].forEach(function (e) { window.removeEventListener(e, kick); }); };
        ['touchstart', 'scroll', 'click'].forEach(function (e) { window.addEventListener(e, kick, { passive: true, once: true }); });
      }
    }

    // variant -> photo: slides tagged "[variant: X]" in alt switch in when X is selected
    function slideAlt(i) {
      var img = slides[i].querySelector('img');
      return ((img && img.alt) || '').toLowerCase();
    }
    function slideForValues(values) {
      for (var v = 0; v < values.length; v++) {
        if (!values[v]) continue;
        var needle = '[variant: ' + values[v].toLowerCase() + ']';
        for (var i = 0; i < slides.length; i++) {
          if (slideAlt(i).indexOf(needle) !== -1) return i;
        }
      }
      return -1;
    }
    function syncGalleryToVariant(values) {
      if (!slides || !slides.length) return; // initial syncVariant() runs before gallery init
      var target = slideForValues(values);
      var current = slides.findIndex(function (s) { return s.classList.contains('on'); });
      if (target !== -1) {
        if (target !== current) activateSlide(target);
      } else if (current !== -1 && slideAlt(current).indexOf('[variant:') !== -1) {
        activateSlide(startIndex); // back to the start slide (the video) when no variant image matches
      }
    }
    // on load the gallery keeps the video start slide; jump to a variant photo
    // only when the visitor followed an explicit ?variant= deep link
    if (groups.length && deepLinkVariant && slideForValues(selectedOptions()) !== -1) {
      syncGalleryToVariant(selectedOptions());
    }

    /* ---------- details: feature switches on click AND on scroll (mobile + desktop) ---------- */
    var accItems = [].slice.call(document.querySelectorAll('#pdpacc .acc-item'));
    var dimg = document.getElementById('pdpdimg');
    var detailsEl = document.querySelector('.pdp-details');
    var activeFeat = 0;
    function setFeature(i) {
      if (i === activeFeat || !accItems[i]) return;
      activeFeat = i;
      accItems.forEach(function (x, k) { x.classList.toggle('on', k === i); });
      var src = accItems[i].dataset.image;
      if (!dimg || !src) return;
      if (reduced || typeof gsap === 'undefined') { dimg.src = src; }
      else {
        gsap.to(dimg, { opacity: 0, scale: 1.04, duration: .25, onComplete: function () {
          dimg.src = src;
          gsap.fromTo(dimg, { opacity: 0, scale: .96 }, { opacity: 1, scale: 1, duration: .4 });
        } });
      }
    }
    accItems.forEach(function (item, i) {
      item.querySelector('.acc-head').addEventListener('click', function () { setFeature(i); });
    });
    // scrollspy: whichever feature crosses the viewport centre becomes active (smooth on mobile + desktop)
    if (detailsEl && accItems.length > 1 && 'IntersectionObserver' in window) {
      var spy = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { var i = accItems.indexOf(e.target); if (i !== -1) setFeature(i); }
        });
      }, { rootMargin: '-50% 0px -50% 0px', threshold: 0 });
      accItems.forEach(function (it) { spy.observe(it); });
    }

    /* ---------- motion ---------- */
    if (reduced || typeof gsap === 'undefined') return;
    gsap.registerPlugin(ScrollTrigger);

    gsap.from('.pdp-buy > *', { y: 26, opacity: 0, duration: .7, ease: 'power2.out', stagger: .07 });
    gsap.utils.toArray('.pdp-details, .pdp-story-in').forEach(function (el) {
      gsap.from(el, { y: 60, opacity: 0, duration: .8, ease: 'power2.out',
        scrollTrigger: { trigger: el, start: 'top 85%' } });
    });
    // the slow float — packshot/ghost breathes in the air
    gsap.utils.toArray('.pdp-float').forEach(function (img, i) {
      gsap.to(img, { y: '-=14', rotation: i % 2 ? 1.2 : -1.2, duration: 3.6, ease: 'sine.inOut', repeat: -1, yoyo: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function () { location.reload(); });
})();
